/**
 * Converts Markdown links in a string to HTML links.
 * @param {string} markdown - The string containing Markdown-formatted links.
 * @param {Object} additionalLinkAttributes - Additional attributes to add to the links.
 * @returns {string} - The string with Markdown links converted to HTML links.
 */
function convertMarkdownLinks(markdown, additionalLinkAttributes = {}, removeAtrributesFromPhoneNumber = false) {
    // Regular expression to match Markdown links, allowing nested parentheses in the URL
    const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+(?:\([^)]*\)[^)]*)*)\)/g;

    // Replace Markdown links with HTML links
    return markdown.replace(markdownLinkRegex, (match, text, url) => {
        const attributes = Object.entries(additionalLinkAttributes)
            .map(([key, value]) => `${key}="${value}"`)
            .join(' ');
        const isPhoneNumber = url.startsWith('tel:');
        return `<a href="${url}" ${isPhoneNumber && removeAtrributesFromPhoneNumber ? '' : attributes}>${text}</a>`;
    });
}

// Example usage
// const markdownString = "This is a [link](https://example.com) in Markdown.";
// const htmlString = convertMarkdownLinks(markdownString);
// console.log(htmlString); // Output: This is a <a href="https://example.com">link</a> in Markdown.

export default convertMarkdownLinks;
